// extracted by mini-css-extract-plugin
var _1 = "X_NuR";
var _2 = "pCCPn";
var _3 = "t5e1W";
export { _1 as "base", _2 as "editor", _3 as "empty" }
